import React from "react";
import { Select, MenuItem } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

// The standard variant renders black text for the light navbar. Both navbar
// mounts reuse this override when the bar behind it goes dark - night mode, or
// the orange inactive-year wash.
export const LIGHT_ON_DARK_SX = {
  color: "#FFFFFF",
  "& .MuiSelect-icon": { color: "#FFFFFF" },
};

export default function SchoolYearSelect({
  years,
  value,
  onChange,
  sx,
  ariaLabel = "School year",
  variant = "standard",
  fullWidth = false,
  size,
}) {
  if (!years?.length) return null;

  const isStandard = variant === "standard";

  return (
    <Select
      variant={variant}
      disableUnderline={isStandard}
      fullWidth={fullWidth}
      size={size}
      value={value ?? ""}
      onChange={onChange}
      IconComponent={ArrowDropDownIcon}
      inputProps={{ "aria-label": ariaLabel }}
      sx={{
        ...(isStandard && {
          fontWeight: "bold",
          fontSize: 20,
          color: "#000000",
        }),
        ...sx,
      }}
    >
      {years.map((sy) => (
        <MenuItem key={sy.id} value={String(sy.id)}>
          {sy.name}
        </MenuItem>
      ))}
    </Select>
  );
}
